var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"4b96bae9851b36992e2c4dc7ae6ac0ba68e01002"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// Client-side error monitoring (self-hosted Sentry, project winit-webapp).
// Auto-loaded by @sentry/nextjs via the webpack plugin injected in next.config.js.
import * as Sentry from "@sentry/nextjs"

Sentry.init({
  dsn:
    process.env.NEXT_PUBLIC_SENTRY_DSN ||
    "https://446b156be1ffda1f9c0b7226861fcbb9@sentry.appwinit.com/5",
  environment: process.env.NEXT_PUBLIC_WINIT_ENV || "production",
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
})
